export enum Events {
  JWT_EXPIRED = "JWT_EXPIRED",
}
